<template>
	<div class="pagination">
		<div class="pagination-l">
			共{{total}}条记录
		</div>
		<el-pagination
		@current-change="handleCurrentChange"
		background
		:total=this.total
		:page-size= this.pageSize
		layout="prev, pager, next, jumper"
		hide-on-single-page
		>
		</el-pagination>
	</div>
</template>

<script>
	export default {
		name: 'PaginationAdmin',
		components: {
			
		},
		props: {
			pageSize: {
				type: Number
			},
			total: {
				type: Number
			}
		},
		data() {
			return {
				
			}
		},
		created(){
			
		},
		methods: {
			handleCurrentChange(e){
				this.$emit('pageChange', {
					number: e
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.pagination {
		display: flex;
		justify-content: space-between;
		margin-top: 15px;
	}
</style>